<template>
  <div></div>
</template>
<script>
import * as Selection from '@simonwep/selection-js';
export default {
  props:{
    element:{
      type:HTMLDivElement,
      required:true
    },
    selections:{
      type:Object,
      required:true
    }
  },
  mounted() {
    this.selection = new Selection({
        // Class for the selection-area-element
        class: 'selection-area',

        // px, how many pixels the point should move before starting the selection (combined distance).
        // Or specifiy the threshold for each axis by passing an object like {x: <number>, y: <number>}.
        startThreshold: 10,

        // Disable the selection functionality for touch devices
        disableTouch: false,

        // On which point an element should be selected.
        // Available modes are cover (cover the entire element), center (touch the center) or
        // the default mode is touch (just touching it).
        mode: 'touch',

        // Behaviour on single-click
        // Available modes are 'native' (element was mouse-event target) or 
        // 'touch' (element got touched)
        tapMode: 'native',

        // Enable single-click selection (Also disables range-selection via shift + ctrl)
        singleClick: false,

        // Query selectors from elements which can be selected
        //selectables: [],
        selectables: ['.selectable-targets .selectionjs-target'],

        // Query selectors for elements from where a selection can be start
        startareas: ['html'],

        // Query selectors for elements which will be used as boundaries for the selection
        boundaries: ['html'],

        // Query selector or dom node to set up container for selection-area-element
        selectionAreaContainer: 'body',

        // On scrollable areas the number on px per frame is devided by this amount.
        // Default is 10 to provide a enjoyable scroll experience.
        scrollSpeedDivider: 10
    });
    this.selection
    .on('beforestart', this.beforeStart)
    .on('start', this.startSelection)
    .on('move', this.moveSelection)
    .on('stop', this.stopSelection);
  },
  data() {
    return {
    }
  },
  beforeDestroy() {
    this.selection.destroy();
  },
  methods:{
    beforeStart({oe}) {
      // This function can return "false" to abort the selection
      if (!oe.ctrlKey && !oe.shiftKey) {
        return false;
      } else {
        return true;
      }

    },
    stopSelection(evt) {
      const selected = evt.selected;
      selected.forEach( (s) => {
        const id = s.dataset.transformId;
        this.$set(this.selections, id, true);
      });
      // shitty timing issue with deselectAll in EditRenderer
      setTimeout( () => {
        this.$emit("stop-selection");
      }, 100);
      evt.oe.preventDefault();
      evt.oe.stopPropagation();
      return false;

    },
    startSelection(evt) {
      this.$emit("start-selection");
    },
    moveSelection({changed: {removed,added}}) {
    }
  }
}
</script>
<style>
.selection-area {
  background-color: red;
}
</style>
